module.exports = __webpack_public_path__ + "static/media/mad.ac79766f.webp";